export default {"src":"/_next/static/media/financiele-hulp.7aea5170.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};